var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-form-control',{attrs:{"mb":"25px"}},[_c('c-form-label',{attrs:{"for":"firstName","font-size":"14px","color":"#555555"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default",function(){return [_c('c-input',_vm._g(_vm._b({directives:[{name:"chakra",rawName:"v-chakra",value:({
          _disabled: {
            opacity: 1,
            background: '#f2f2f2'
          }
        }),expression:"{\n          _disabled: {\n            opacity: 1,\n            background: '#f2f2f2'\n          }\n        }"}],attrs:{"h":"62px","border":"1px solid #c4c4c4","border-radius":"md"}},'c-input',_vm.$attrs,false),_vm.$listeners))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }